// extracted by mini-css-extract-plugin
module.exports = {"dialog":"kVl9xuZ_h6QzkWsboZheC","image":"_1EJYK4YNXKAJdYoeJMrIBf","content-wrapper":"BwEgUWBa2tX4D83FHPuwN","content":"_2tf9_lx2hdSmJ0tmxaWtfn","footer":"_2gktonp7mYtU4lGRJFnmux"};